// TODO: This page is not part of the official requirements or Figma designs — added for debugging/testing purposes only.
import styled from 'styled-components'

export const ActionsRow = styled.div<{ $disabled: boolean }>(({ theme, $disabled }) => ({
  '[data-component-id="Badge"]': {
    '&:hover': {
      opacity: $disabled ? 0.4 : 0.75,
    },
    cursor: $disabled ? 'not-allowed' : 'pointer',
    transition: 'opacity 150ms ease',
  },
  display: 'flex',
  gap: theme.space['8'],
  opacity: $disabled ? 0.4 : 1,
  pointerEvents: $disabled ? 'none' : 'auto',
  transition: 'opacity 150ms ease',
}))

export const ContentWrapper = styled.div(() => ({
  minHeight: '20rem',
  position: 'relative',
}))

export const LoadingOverlay = styled.div(({ theme }) => ({
  alignItems: 'center',
  background: theme.colors.white,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  left: 0,
  opacity: 0.7,
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: theme.zIndex.level1,
}))
